import TNTControlBase from '../../util/TNTControlBase';

class DenominationController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'denomination'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default DenominationController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/denomination.controller.js